import React, { useEffect, useState } from 'react';
import './PreviewInfoBox.css';

export default function PreviewInfoBox({ isAdmin, isSummaryMode, loading }) {
  const [showPreviewInfo, setShowPreviewInfo] = useState(true);

  // Preview-Info-Box nach 10 Sekunden ausblenden
  useEffect(() => {
    if (isAdmin && isSummaryMode && !loading && showPreviewInfo) {
      const timer = setTimeout(() => {
        setShowPreviewInfo(false);
      }, 10000); // 10 Sekunden
      return () => clearTimeout(timer);
    } else if (!isSummaryMode) {
      // Reset wenn nicht mehr im Summary-Modus
      setShowPreviewInfo(true);
    }
  }, [isAdmin, isSummaryMode, loading, showPreviewInfo]);

  if (!isAdmin || !isSummaryMode || loading || !showPreviewInfo) {
    return null;
  }

  return (
    <div className="admin-info-box">
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: '0.75rem' }}>
        <div style={{ 
          fontSize: '1.25rem', 
          lineHeight: '1',
          flexShrink: 0,
          marginTop: '0.1rem'
        }}>
          💡
        </div>
        <div style={{ flex: 1 }}>
          <strong style={{ 
            display: 'block', 
            marginBottom: '0.25rem',
            color: '#856404',
            fontSize: '0.95rem'
          }}>
            Preview-Modus
          </strong>
          <p style={{ 
            margin: 0, 
            color: '#856404',
            fontSize: '0.875rem',
            lineHeight: '1.5'
          }}>
            Bitte wähle einen Kunden aus, um die Dokumente richtig zu sehen. Du siehst aktuell nur eine Preview.
          </p>
        </div>
        <button
          onClick={() => {
            // Scroll zum Filter
            const filterElement = document.querySelector('.documents-filters');
            if (filterElement) {
              filterElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            }
          }}
          style={{
            background: 'transparent',
            border: 'none',
            color: '#856404',
            fontSize: '1.25rem',
            cursor: 'pointer',
            padding: '0',
            lineHeight: '1',
            opacity: 0.7,
            transition: 'opacity 0.2s',
            flexShrink: 0
          }}
          onMouseEnter={(e) => e.target.style.opacity = '1'}
          onMouseLeave={(e) => e.target.style.opacity = '0.7'}
          title="Zum Filter scrollen"
        >
          ↓
        </button>
      </div>
    </div>
  );
}

